import React from 'react';
import { AccessibilityRole, StyleSheet } from 'react-native';

import { View } from '@fhs-legacy/universal-components';

/**
 * Renders content that is visually hidden but remains accessible to screen readers.
 * Uses the "sr-only" CSS technique instead of display:none, which would remove
 * the element from the accessibility tree entirely.
 */
export const VisuallyHidden: React.FC<
  React.PropsWithChildren<{
    accessibilityLabel: string;
    role?: AccessibilityRole;
    testID?: string;
  }>
> = ({ accessibilityLabel, role, testID, children }) => (
  <View
    accessibilityRole={role}
    accessibilityLabel={accessibilityLabel}
    testID={testID}
    style={styles.srOnly}
  >
    {children}
  </View>
);

const styles = StyleSheet.create({
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    borderWidth: 0,
  },
});
